export enum EIndependenceType {
  UNKNOWN = 'unknown',
  INDEPENDENT = 'independent',
  PART = 'part',
}
